import React, { Component } from "react";
import { Button, FormGroup, FormControl, ControlLabel, Panel } from "react-bootstrap";
import "./Login.css";
import UserProfile from './UserProfile';
import AlertElement from './UI/Alert/Alert';
import Input from './UI/Input/Input';
import axios from 'axios';

export class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            time: "",
            email: "",
            password: "",
            loading: false,
            showerror: false,
            errorheader: '',
            errortext: '',
            formsconfig:
            {
                show: false,
                type: 0,
            },
            objform: {
                name: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'text',
                        placeholder: 'Utente'
                    },
                    value: '',
                    validation: {
                        required: true
                    },
                    valid: false,
                    touched: true
                },
                password1: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'text',
                        placeholder: 'Vecchia Password'
                    },
                    value: '',
                    validation: {
                        required: true
                    },
                    valid: false,
                    touched: true
                },
                password2: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'text',
                        placeholder: 'Nuova Password'
                    },
                    value: '',
                    validation: {
                        required: true
                    },
                    valid: false,
                    touched: true
                }
            }
        };
    }
    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (this.validateForm()) this.loginClick();
        }
    }
    forceRender = event => {
        this.setState({ time: Date.now() })
    }
    validateForm() {
        if (this.state == undefined || this.state.email == undefined || this.state.password == undefined) return false;
        return this.state.email.length > 0 && this.state.password.length > 0 && !this.state.loading;
    }
    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    }
    loginClick = event => {
        this.state.loading = true;
        let data = JSON.stringify({
            Name: this.state.email,
            Password: this.state.password
        })
        axios.post('api/User/Login', data, { headers: { 'Content-Type': 'application/json' } })
            .then(respose => {
                this.state.loading = false;
                if (respose.data === null || respose.data.token === null) {
                    this.setState(prevState => {
                        console.log('Error login');
                        this.state.formsconfig.show = false;
                        this.state.showerror = true;
                        this.state.errorheader = 'Errore login:';
                        this.state.errortext = 'Credenziali non valide';
                        this.setState(prevState => {
                            let updatingstate = Object.assign({}, prevState);
                            updatingstate.formsconfig.show = false;
                            return { updatingstate };
                        })
                    })
                } else {
                    UserProfile.saveLogin(respose.data);
                    this.setState(prevState => {
                        let updatingstate = Object.assign({}, prevState);
                        updatingstate.formsconfig.show = false;
                        return { updatingstate };
                    })
                }
            })
            .catch(data => {
                this.state.showerror = true;
                this.state.loading = false;
                this.forceRender();
            });
    }

    logoutClick = event => {
        UserProfile.saveLogout();
        this.forceRender();
    }
    Chiudi = event => {
        this.setState(prevState => {
            let updatingstate = Object.assign({}, prevState);
            updatingstate.formsconfig.show = false;
            return { updatingstate };
        })
    }
    changePasswordRequestClick = event => {
        this.setState(prevState => {
            let updatingstate = Object.assign({}, prevState);
            updatingstate.objform.name.value = UserProfile.getLogin().username;
            updatingstate.formsconfig.show = true;
            this.state.objform.password1.value = '';
            this.state.objform.password2.value = '';
            return { updatingstate };
        })
    }
    clickdismiss() {
        this.state.showerror = false;
        this.forceRender();
    }
    ChangePassword = event => {
        let data = JSON.stringify({
            Token: UserProfile.getLogin().token,
            Name: this.state.objform.name.value,
            Password1: this.state.objform.password1.value,
            Password2: this.state.objform.password2.value
        })
        axios.post('api/User/ChangePassword', data, { headers: { 'Content-Type': 'application/json' } })
            .then(respose => {
                this.setState(prevState => {
                    if (respose.data != '') {
                        this.setState(prevState => {
                            let updatingstate = Object.assign({}, prevState);
                            updatingstate.showerror = true;
                            updatingstate.errorheader = 'Errore cambio password:';
                            updatingstate.errortext = respose.data;
                            return { updatingstate };
                        })
                    } else {
                        this.setState(prevState => {
                            let updatingstate = Object.assign({}, prevState);
                            updatingstate.showerror = false;
                            return { updatingstate };
                        })
                    }
                    let updatingstate = Object.assign({}, prevState);
                    updatingstate.formsconfig.show = false;
                    return { updatingstate };
                })
                this.refresh();
            })
    }
    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    }
    inputChangedHandler = (event, inputIdentifier) => {
        const updatedForm = {
            ...this.state.objform
        };
        const updatedFormElement = {
            ...updatedForm[inputIdentifier]
        };
        updatedFormElement.value = event.target.value;
        updatedFormElement.valid = true;
        updatedFormElement.touched = true;
        updatedForm[inputIdentifier] = updatedFormElement;

        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
        }
        this.setState({ objform: updatedForm, formIsValid: formIsValid });
    }
    render() {
        const formElementsArray = [];
        for (let key in this.state.objform) {
            formElementsArray.push({
                id: key,
                config: this.state.objform[key]
            });
        }
        let formChangePassword = (
            <div>
                <form>
                    {formElementsArray.map(formElement => (
                        <Input
                            key={formElement.id}
                            elementType={formElement.config.elementType}
                            elementConfig={formElement.config.elementConfig}
                            value={formElement.config.value}
                            invalid={!formElement.config.valid}
                            shouldValidate={formElement.config.validation}
                            touched={formElement.config.touched}
                            changed={(event) => this.inputChangedHandler(event, formElement.id)}
                            textdisabled={formElement.id === "name" ? true : false} />
                    ))}
                </form>
                
                <div className="row">
                    <div className="col-sm-6">
                        <Button block bsSize="large" onClick={(event) => this.ChangePassword(event)} type="button" className="btn btn-warning btn-action">  Modifica </Button>
                    </div>
                    <div className="col-sm-6">
                        <Button block bsSize="large" onClick={(event) => this.Chiudi(event)} type="button" className="btn btn-secondary btn-action">  Chiudi </Button>
                    </div>
                </div>
            </div>
        );
        let formCredential = (
            <div className="Login">
                {(UserProfile.IsAuth() == false) &&
                    <form>
                        <FormGroup controlId="email" bsSize="large">
                            <ControlLabel>Utente \ Email</ControlLabel>
                            <FormControl
                                autoFocus
                                value={this.state.email}
                                onChange={this.handleChange}
                            />
                        </FormGroup>
                        <FormGroup controlId="password" bsSize="large">
                            <ControlLabel>Password</ControlLabel>
                            <FormControl
                                autoFocus
                                value={this.state.password}
                                onChange={this.handleChange}
                                type="password"
                            />
                        </FormGroup>
                        <Button block bsSize="large" disabled={!this.validateForm()} onClick={(event) => this.loginClick(event)} variant="outline-dark" type="button" className="btn btn-success">  Login </Button>
                    </form>}
                {(UserProfile.IsAuth() == true) &&
                    <form>
                        <FormGroup bsSize="large">
                            <ControlLabel>Email</ControlLabel>
                            <FormControl
                                autoFocus
                                value={UserProfile.getLogin().email}
                                disabled
                            />
                        </FormGroup>
                        <FormGroup bsSize="large">
                            <ControlLabel>Utente</ControlLabel>
                            <FormControl
                                value={UserProfile.getLogin().username}
                                disabled
                            />
                        </FormGroup>
                        <FormGroup bsSize="large">
                            <ControlLabel>Matricola</ControlLabel>
                            <FormControl
                                value={UserProfile.getLogin().matricola}
                                disabled
                            />
                        </FormGroup>
                        <Button block bsSize="large" onClick={(event) => this.logoutClick(event)} type="button" className="btn btn-danger" >  Logout </Button>
                        <Button block bsSize="large" onClick={(event) => this.changePasswordRequestClick(event)} type="button" className="btn btn-primary" >  Cambia Password </Button>
                    </form>}
            </div>
        );
        return (
            <span className="border border-dark rounded" onKeyDown={this._handleKeyDown}>
                {(this.state.showerror == true) && <AlertElement strong={this.state.errorheader} message={this.state.errortext} clicked={(event) => this.clickdismiss(event)} />}
                {(this.state.formsconfig.show === true) && formChangePassword}
                {(this.state.formsconfig.show === false) && formCredential}
            </span>
        );
    }
}
